/**
 * Appels API pour les actions spontanées.
 */

import api from "./axiosConfig";

/**
 * Récupère la liste des actions spontanées de l'utilisateur.
 * @returns {Promise<Array>} Liste des actions.
 */
export async function getActions(sortBy = "action_date") {
  const response = await api.get(`/spontaneous-actions?sort_by=${sortBy}`);
  return response.data;
}

/**
 * Récupère une action spontanée par son ID.
 * @param {number} id - Identifiant de l'action.
 * @returns {Promise<Object>} L'action.
 */
export async function getAction(id) {
  const response = await api.get(`/spontaneous-actions/${id}`);
  return response.data;
}

/**
 * Crée une nouvelle action spontanée.
 * @param {Object} data - Données de l'action.
 * @returns {Promise<Object>} L'action créée.
 */
export async function createAction(data) {
  const response = await api.post("/spontaneous-actions", data);
  return response.data;
}

/**
 * Met à jour une action spontanée existante.
 * @param {number} id - Identifiant de l'action.
 * @param {Object} data - Champs à modifier.
 * @returns {Promise<Object>} L'action mise à jour.
 */
export async function updateAction(id, data) {
  const response = await api.put(`/spontaneous-actions/${id}`, data);
  return response.data;
}

/**
 * Supprime une action spontanée.
 * @param {number} id - Identifiant de l'action.
 * @returns {Promise<void>}
 */
export async function deleteAction(id) {
  await api.delete(`/spontaneous-actions/${id}`);
}
